import {Folder} from '../../../Assets.types';

/**
 * Immutably remove an asset from the tree
 * @param assetTree - The tree structure
 * @param assetId - ID of the asset to remove
 * @returns New tree with asset removed
 */
export default function removeAssetFromTree(
  assetTree: Folder | null,
  assetId: number,
): Folder | null {
  if (!assetTree) {
    return null;
  }

  function removeFolderAsset(folder: Folder): Folder {
    // Filter out the asset from this folder
    const filteredAssets = folder.assets?.filter((asset) => asset.id !== assetId);

    // Recursively process nested folders
    const updatedFolders = folder.folders?.map(removeFolderAsset);

    return {
      ...folder,
      assets: filteredAssets,
      folders: updatedFolders,
    };
  }

  return removeFolderAsset(assetTree);
}

